import { SettingType, SettingsProvider } from '@fluidx/office-fluid-types';
import { getSettingsValue } from './settingsValue';

// This is the name of the FluidExperiences team in the Fluid ECS account.
const fluidExperiencesEcsTeamName = 'FluidExperiences';

// Add a settingName as a string to enable EcsSettingsProvider to serve the setting from ECS
// This is a temporary gate we are using when migrating to the new settings contract
// TODO: Task 4999997: Clean up List of Settings to grab from ECS
const ecsEnabledSettings: string[] = ['FluidEcsE2ETest'];

/**
 * Verifies that a setting is enabled to be served from ECS
 * @param settingName Name of the setting to verify
 * @returns a boolean stating wether a settings should be served from ECS or not
 */
function settingIsEcsEnabled(settingName: string): boolean {
  return ecsEnabledSettings.includes(settingName);
}

export function getFluidExperiencesSetting<T extends SettingType>(
  settingName: string,
  defaultValue: T,
  settingsProvider: SettingsProvider | undefined
): T {
  if (settingsProvider) {
    // checking if the setting should be grabbed from ECS or from the current getSettingsValue API
    // to enable a setting to be grabbed from ECS, add the settingName to ecsEnabledSettings
    if (settingIsEcsEnabled(settingName)) {
      return settingsProvider.getSetting(settingName, defaultValue, fluidExperiencesEcsTeamName);
    }
  }

  // TODO: Task 5062886: Remove getSettingsValue API call from getFluidExperiencesSetting
  // If the setting is not EcsEnabled, and want to use the legacy getSettingsValue API, it should be a boolean.
  // If the value is not a boolean, the getSettingsValue API is not going to accept it as a parameter, so returning the default value.
  if (typeof defaultValue === 'boolean') {
    // here T is a boolean because defaultValue type is boolean
    return getSettingsValue({
      name: settingName,
      defaultValue
    }) as T;
  }

  return defaultValue;
}
